import React, {useEffect, useState} from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import './Blog.css';
import axios from 'axios';

const BlogDetail = (props) => {
    const [data, setData] = useState({});
    const [blogVideo, setBlogVideo] = useState([]);
    const { id } = useParams();
    const history = useHistory();

    useEffect(() => {
        let newState = {};
        //window.scrollTo(0, 0);
        axios.get('https://appi.colexion.io/api/Blog').then(resp => {
            newState = {...newState, data: resp.data.find((blog) => blog._id === id)};
            newState = {
                ...newState, 
                relatedArticle: 
                    resp.data.filter(
                        blog => 
                            blog.category === newState.data.category 
                            && newState.data._id !== blog._id),
                EditorsChoice: resp.data.filter(blog => blog.editorchoice > 0)};
                axios.get('https://appi.colexion.io/api/Ads').then(resp1 => {
                    newState = {...newState, Ads: resp1.data}
                    console.log(newState);
                    setData(newState);
                });
            });
            axios.get('https://appi.colexion.io/api/bvids').then(resp => {
                setBlogVideo(resp.data);
            });
            setTimeout(()=>{
                window.scrollTo(0, 0)
            }, 100)
    }, [id])

    const getDate = (date) => {
        var months = [ "January", "February", "March", "April", "May", "June", 
           "July", "August", "September", "October", "November", "December" ];
        if(date){
            const Date_new = date.substring(0,10).split('-');
            return (months[Date_new[1]-1] + ' ' + Date_new[2] + ', ' + Date_new[0]);
        }
        return undefined;
    }

    return(
        <div className="blog_detail">
            {data.data !== undefined ?
            <div className="container whiteTheme">
                <div className="row">
                    <div className="row back-container">
                        <button className="normalLink" onClick={() => history.goBack()}><i className="fas fa-arrow-left"></i> Back</button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <img className="blog-detail-img" src={`https://appi.colexion.io/${data.data.img}`} alt="" />
                    </div>
                    <div className="col-md-6">
                        <p className="details-Wallets">{data.data.category}</p>
                        <p className="Which-Indian-Detail">{data.data.title}</p>
                        <div class="By-Rohan-Hada">By {data.data.author}</div>
                        <div class="September-16-2022">{getDate(data.data.createdAt)}</div>
                        <div class="Last-update-on-September-16-2022">Last update on: {getDate(data.data.updatedAt)}</div>  
                    </div>
                </div>
                <div class="Line-21"></div>
                <div className="row">
                    <div className="col-md-8 left-column-details">
                        <div class="How-Artists-are-gaining-exposure-from-NFTs">
                            {data.data.title}
                        </div>
                        <div class="If-you-are-an-Artist">
                            
                            <p dangerouslySetInnerHTML={{ __html: data.data.content }}></p>
                        </div>  
                        {/* <div className="rec-box">
                            <div class="Rectangle-283"></div>
                            <div class="To-catch-peoples">
                                To catch people’s attention develop your NFT artworks with amusing concepts that generally attracts people.
                            </div>
                        </div> */}
                        <div class="Line-16"></div>
                        <div className="related-container">
                            { data.relatedArticle.length !== 0 &&<>
                            <div class="Related-Articles">Related Articles:</div>
                            {data.relatedArticle.map((article) => {
                                return(
                                <div className="row my-2" key={article._id}>
                                    <div class="Rectangle-286"></div>
                                    <Link to={`/blog-detail/${article._id}`} class="Indias-Regulatory">
                                        {article.title}
                                    </Link>
                                </div>)
                            })} </> }
                        </div>
                    </div>
                    <div className="col-md-4">
                        {data.EditorsChoice && <><div class="Editor-Wallets">EDITOR'S CHOICE</div>
                        {
                            <div>
                            {data.EditorsChoice.slice(0,1).map((editor) => {
                                return(
                                    <div key={editor._id}>
                                        <Link  to={`/blog-detail/${editor._id}`} class="What-is-Ripple-The-Journey-from-a-Money-Transfer-Platform">
                                            {editor.title}
                                        </Link>
                                    </div>
                                )
                                })
                            }
                            {data.EditorsChoice.slice(1, data.EditorsChoice.length).map((editor) => {
                                return(
                                    <div key={editor._id}>
                                        <div class="Line-16"></div>
                                        <Link to={`/blog-detail/${editor._id}`} class="Will-NFT-culture-survive-or-will-the-bubble-burst">
                                            {editor.title}
                                        </Link>
                                    </div>
                                    )
                                })
                            }
                            <div class="Line-16"></div>
                            </div>
                        }</>}
                        {/* <a href={data.Ads[0].url} without rel="noreferrer" target="_blank"><img className="btc-img" src={"https://appi.colexion.io/" + data.Ads[0].img} alt=""  /></a> */}
                        <div className="blgVdo">
                            {blogVideo.map((video) => {
                                return(
                                    <iframe width="100%" height="400" src={video.bvideo} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                )
                            })}
                        </div>
                        <div>
                            <a href={data.Ads[0].url} without rel="noreferrer" target="_blank"><img className="btc-img" src={"https://appi.colexion.io/" + data.Ads[0].img} alt=""  /></a>
                        </div>
                    </div>
                </div>
                <div className="related-container-sm">
                    <div class="Related-Articles">Related Articles:</div>
                    {data.relatedArticle.map((article) => {
                        return(
                        <div className="row my-2" key={article._id}>
                            <div class="Rectangle-286"></div>
                            <Link to={`/blog-detail/${article._id}`} class="Indias-Regulatory">
                                {article.title}
                            </Link>
                        </div>)
                    })}
                </div>
            </div> : ''}
        </div>
    )
}

export default BlogDetail;